import mapper from 'object-mapper';

const fromApiMap = {
  id: 'id',
  userName: 'userName',
  email: 'email',
  name: 'name',
  firstSurname: 'firstSurname',
  secondSurname: 'secondSurname',
  role: {
    transform: (srcValue, srcObject) => {
      if (!srcObject.companies || srcObject.companies.length === 0) {
        return 'ADMINISTRADOR';
      }
      return srcObject.companies[0]?.role || '';
    }
  },
  roleName: {
    transform: (srcValue, srcObject) => {
      if (!srcObject.companies || srcObject.companies.length === 0) {
        return 'Administrator';
      }
      const hasAdmin = srcObject.companies.some(c => c.role === 'ADMINISTRADOR' || c.role === 'ADMINISTRADOR EMPRESA');
      if (hasAdmin) {
        return 'Administrator';
      }
      const hasManager = srcObject.companies.some(c => c.role === 'RESPONSABLE');
      if (hasManager) {
        return 'Manager';
      }
      return 'ForestOwner';
    }
  },
  active: 'active',
  superadmin: 'superadmin',
  clients: [
    {
      key: 'clients'
    },
    {
      key: 'clientsIdentifiers',
      transform: (srcValue, srcObject) => {
        if (srcValue && !srcObject?.clientsIdentifiers) {
          return srcValue.map(client => client?.id);
        }
        return undefined;
      }
    }
  ],
  clientsIdentifiers: 'clientsIdentifiers',
  companies: {
    key: 'companies',
    transform: (srcValue, srcObject) => {
      if (srcObject.superadmin === true) {
        return [];
      }
      return srcValue || [];
    }
  },
  companyRoles: {
    key: 'companyRoles',
    transform: (srcValue, srcObject) => {
      if (srcObject.superadmin === true) {
        return [];
      }
      const companies = srcObject.companies || [];
      if (!companies.length) {
        return [];
      }
      return companies
        .filter(c => c.role && String(c.role).toUpperCase() !== 'SUPERADMIN')
        .map(c => ({
          companyId: c.companyId,
          role: c.role
        }));
    }
  },
  isSuperadmin: {
    key: 'isSuperadmin',
    transform: (srcValue, srcObject) => srcObject.superadmin === true
  }
};

const toApiMap = {
  id: 'id',
  userName: 'userName',
  email: 'email',
  name: 'name',
  firstSurname: 'firstSurname',
  secondSurname: 'secondSurname',
  role: {
    transform: (srcValue, srcObject) => {
      if (srcObject?.isSuperadmin === true || srcObject?.superadmin === true) {
        return undefined;
      }
      return (
        srcObject?.companyRoles?.[0]?.role ||
        srcObject?.role ||
        'ADMINISTRADOR'
      );
    }
  },
  active: 'active',
  // Origen: isSuperadmin (react-hook-form). Destino JSON: superadmin (API).
  isSuperadmin: 'superadmin',
  clients: 'clients',
  clientsIdentifiers: 'clientsIdentifiers',
  companies: {
    transform: (srcValue, srcObject) => {
      if (srcObject?.isSuperadmin === true || srcObject?.superadmin === true) {
        return [];
      }
      const firstRole = srcObject?.companyRoles?.[0]?.role || srcObject?.role;
      if (firstRole === 'ADMINISTRADOR') {
        return [];
      }
      return (srcObject?.companyRoles || []).filter(
        item => item?.role && item?.companyId
      );
    }
  }
};

export default {
  toApi: src => mapper(src, toApiMap),
  fromApi: src => mapper(src, fromApiMap),
  maps: {
    fromApiMap,
    toApiMap
  }
};
